import React, {Component} from "react";

import PropTypes from "prop-types";
import {connect} from "react-redux";

import HintsModal from "./hints-modal";
import {purchaseHint} from "../../../ducks/duck-game";
import {addToast, updateActiveLogoWithHint} from "../../../ducks/duck-screen";


class HintsModalContainer extends Component {

	// state = {
	// 	activeRiddleMock: {
	// 		answer: ["Samsung"],
	// 		dateSolved: {seconds: 1561819415, nanoseconds: 423000000},
	// 		gameType: "classic",
	// 		hashArray: ["968e2d5b08687bf42997461cbdef6c844eabbf04f440cee888c95b864c2a4bcc"],
	// 		hintClue1Used: false,
	// 		hintClue2Used: false,
	// 		img: "samsung_2",
	// 		imgSolved: "samsung_4",
	// 		isSolved: true,
	// 		language: "en",
	// 		levelOrder: 1,
	// 		lp: 1,
	// 		points: 3,
	// 		riddleKey: "Samsung-en123",
	// 		wikipediaUrl: "http://en.wikipedia.org/wiki/Samsung",
	// 		wrongGuessTries: 0,
	// 	}
	// }

	// updateClue = (key, text) => {
	// 	console.log(Object.assign({}, this.state.activeRiddleMock, {[key]: text}))
	// 	this.setState({activeRiddleMock: Object.assign({}, this.state.activeRiddleMock, {[key]: text})})
	// }

	render(){
		return (
			<HintsModal {...this.props}/>
		)
	}
}

HintsModalContainer.propTypes = {
	hintCount: PropTypes.number.isRequired,

	activeLogo: PropTypes.object.isRequired,
	hintPrice: PropTypes.object.isRequired,

	removeModalWindow: PropTypes.func.isRequired,
	purchaseHint: PropTypes.func.isRequired,
	updateActiveLogoWithHint: PropTypes.func.isRequired,
	addToast: PropTypes.func.isRequired,
}

function mapStateToProps(state){
	return {
		hintPrice: state.configReducer.appConfig.strings.hintPrice,
		hintCount: state.userReducer.user.hintCount,
		activeLogo: state.screenReducer.activeLogo
	}
}


export default connect(
	mapStateToProps,
	{
		purchaseHint,
		updateActiveLogoWithHint,
		addToast
	}
)(HintsModalContainer);
